import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, TableRow, TableHead, Table, TableBody, TableCell} from '@material-ui/core'



 

export default class ExplicatieIndicatori extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth='md'
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
                 <h2 className='pm-dialog-alert-title'>{this.props.title}</h2>
            <DialogContent>
            <Table>
                       <TableHead>
                           <TableRow>
                               <TableCell style={{fontSize:14, fontWeight:600}}>
                                   Calificativ
                               </TableCell>
                               <TableCell style={{fontSize:14, fontWeight:600}}>
                                   Conditie
                               </TableCell>

                           </TableRow>
                       </TableHead>

                       <TableBody>
                           {this.props.clsExpl.map((cls,idx)=>{
                               return(
                                   <TableRow key={idx}>
                                       <TableCell >
                                        {cls.Label}
                                       </TableCell>
                                       <TableCell >
                                           {cls.Value}
                                           </TableCell>
                                   </TableRow>
                               )
                           })}
                       </TableBody>
                   </Table>
            </DialogContent>
                   
                       
                   
                 </Dialog>
         </div>
        );
       }
}